<div class="export-modal">
  <div class="export-modal__header">
    <div class="export-modal__title">
      @if (currentStep === 'format') {
      <i class="fa-solid fa-download"></i>
      <span>Exportar reporte</span>
      } @else { @if (showFormatSelection) {
      <button class="export-modal__back" (click)="goBackToFormat()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      }
      <i class="fa-solid {{ formatIcon }} {{ formatIconColor }}"></i>
      <span>Exportar a {{ formatLabel }}</span>
      }
    </div>
    <button type="button" class="export-modal__close" (click)="onCancel()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="export-modal__body">
    <!-- PASO 1: Selección de formato -->
    @if (currentStep === 'format') {
    <p class="export-modal__label">¿En qué formato desea exportar?</p>

    <div class="export-modal__formats">
      <button
        class="export-modal__format-btn export-modal__format-btn--pdf"
        (click)="selectFormat('pdf')"
      >
        <div class="export-modal__format-icon">
          <i class="fa-solid fa-file-pdf"></i>
        </div>
        <div class="export-modal__format-info">
          <span class="export-modal__format-name">PDF</span>
          <span class="export-modal__format-desc">Documento portable</span>
        </div>
        <i class="fa-solid fa-chevron-right export-modal__format-arrow"></i>
      </button>

      <button
        class="export-modal__format-btn export-modal__format-btn--excel"
        (click)="selectFormat('excel')"
      >
        <div class="export-modal__format-icon">
          <i class="fa-solid fa-file-excel"></i>
        </div>
        <div class="export-modal__format-info">
          <span class="export-modal__format-name">Excel</span>
          <span class="export-modal__format-desc">Hoja de cálculo</span>
        </div>
        <i class="fa-solid fa-chevron-right export-modal__format-arrow"></i>
      </button>
    </div>
    }

    <!-- PASO 2: Selección de cantidad -->
    @if (currentStep === 'limit') {
    <p class="export-modal__label">¿Cuántos registros desea exportar?</p>
    @if (hasFilters) {
    <p class="export-modal__sublabel export-modal__sublabel--filters">
      <i class="fa-solid fa-filter"></i>
      Filtros aplicados • <strong>{{ totalRecords | number }}</strong> registros
      encontrados
    </p>
    } @else {
    <p class="export-modal__sublabel">
      Total disponible: <strong>{{ totalRecords | number }}</strong> registros
    </p>
    }

    <div class="export-modal__options">
      @for (option of limitOptions; track option.value) {
      <label
        class="export-modal__option"
        [class.export-modal__option--selected]="selectedLimit === option.value"
      >
        <input
          type="radio"
          name="exportLimit"
          [value]="option.value"
          [(ngModel)]="selectedLimit"
          class="export-modal__radio"
        />
        <div class="export-modal__option-content">
          <span class="export-modal__option-label">{{ option.label }}</span>
          <span class="export-modal__option-hint">{{
            getOptionHint(option.value)
          }}</span>
        </div>
      </label>
      }
    </div>
    }
  </div>

  <!-- Footer solo en paso de cantidad -->
  @if (currentStep === 'limit') {
  <div class="export-modal__footer">
    <button type="button" class="export-modal__btn-cancel" (click)="onCancel()">
      Cancelar
    </button>
    <button
      type="button"
      class="export-modal__btn-confirm"
      [disabled]="!selectedFormat"
      (click)="onConfirm()"
    >
      <i class="fa-solid fa-download"></i>
      Exportar
    </button>
  </div>
  }
</div>
